import React from 'react';
import { types, flow } from 'mobx-state-tree';
import utils from '@utils';
import { RPC_URL_DEV } from '@constants/system';

const RootStore = types
  .model({
    isDevelop: types.optional(types.boolean, false),
    anonymousClient: types.optional(types.frozen(null)),
    browserInfo: types.optional(types.frozen(null)),
  })
  .actions((self) => {
    const configAnonymousClient = flow(function* (url) {
      if (url === RPC_URL_DEV) {
        self.anonymousClient = null;
      }
      self.anonymousClient = yield utils.createAnonymousClient(url);
    });
    return { configAnonymousClient };
  })
  .actions((self) => ({
    afterCreate() {
      // info browser
      const sayswho = (() => {
        let tem;
        const ua = navigator.userAgent;
        let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

        if (/trident/i.test(M[1])) {
          tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
          return ['IE ', tem[1] || ''];
        }
        if (M[1] === 'Chrome') {
          tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
          if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        tem = ua.match(/version\/(\d+)/i);
        if (tem != null) M.splice(1, 1, tem[1]);
        return M;
      })();

      const isMobile = /iPhone|Android/i.test(navigator.userAgent);
      const isAndroid = /Android/i.test(navigator.userAgent);
      const isIPhone = /iPhone/i.test(navigator.userAgent);
      const isSensor = /iPhone|iPad|Android/i.test(navigator.userAgent);
      
      let isSafari = false;
      let isChrome = false;

      const browserUse = sayswho;
      if (browserUse && browserUse.length === 2) {
        const browserName = browserUse[0];
        let isOldBrowser = true;
        const majorNumberVersion = Number(browserUse[1].split('.')[0] || 1);
        if (
          (browserName.toLowerCase() === 'safari' && majorNumberVersion >= 15) ||
          (browserName.toLowerCase() === 'firefox' && majorNumberVersion >= 55) ||
          (browserName.toLowerCase() === 'chrome' && majorNumberVersion >= 54) ||
          (browserName.toLowerCase() === 'opera' && majorNumberVersion >= 41)
        ) {
          isOldBrowser = false;
        }
        if (browserName.toLowerCase() === 'safari') {
          isSafari = true;
        }
        if (browserName.toLowerCase() === 'chrome') {
          isChrome = true;
        }
        self.browserInfo = {
          name: browserUse[0],
          version: browserUse[1],
          isOldBrowser,
          isMobile,
          isAndroid,
          isSensor,
          isIPhone,
          isSafari,
          isChrome,
        };
      } else {
        self.browserInfo = { isMobile, isSensor, isIPhone, isAndroid, isSafari, isChrome };
      }
    },
    setDevelop(isDevelop) {
      self.isDevelop = isDevelop;
    },
  }))
  .views((self) => ({
    get isAnonymousClientConfigured() {
      return !!self.anonymousClient;
    },
  }));

export const RootStoreInstance = RootStore.create({});
export const ContextStore = React.createContext(RootStoreInstance);
export const ProviderStore = ContextStore.Provider;

export const useStores = () => {
  return React.useContext(ContextStore);
};
